var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orders-view-wrapper"},[(_vm.isOperator)?_c('orders-operator'):_c('orders')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }